// Animated Streak Flame Component
import { useState, useEffect } from 'react';
import { Flame } from 'lucide-react';

export default function StreakFlame({ streak = 0, size = 'md' }) {
  const [flicker, setFlicker] = useState(false);
  
  // Flicker animation
  useEffect(() => {
    if (streak > 0) {
      const interval = setInterval(() => {
        setFlicker(f => !f);
      }, 150 + Math.random() * 100);
      return () => clearInterval(interval);
    }
  }, [streak]);
  
  const sizes = {
    sm: { flame: 16, text: 'text-sm' },
    md: { flame: 24, text: 'text-lg' },
    lg: { flame: 32, text: 'text-2xl' }
  };
  
  const { flame: flameSize, text: textSize } = sizes[size] || sizes.md;
  
  // Color intensity based on streak
  const getFlameColor = () => {
    if (streak >= 30) return 'text-red-500';
    if (streak >= 14) return 'text-orange-500';
    if (streak >= 7) return 'text-yellow-500';
    if (streak >= 3) return 'text-yellow-400';
    return 'text-gray-400';
  };
  
  // Glow intensity based on streak
  const getGlow = () => {
    if (streak >= 30) return 'drop-shadow-[0_0_8px_rgba(239,68,68,0.8)]';
    if (streak >= 14) return 'drop-shadow-[0_0_6px_rgba(249,115,22,0.7)]';
    if (streak >= 7) return 'drop-shadow-[0_0_4px_rgba(234,179,8,0.6)]';
    if (streak >= 3) return 'drop-shadow-[0_0_3px_rgba(250,204,21,0.5)]';
    return '';
  };
  
  if (streak === 0) {
    return (
      <div className="flex items-center gap-1 text-muted-foreground">
        <Flame size={flameSize} className="opacity-30" />
        <span className={textSize}>0</span>
      </div>
    );
  }
  
  return (
    <div className="flex items-center gap-1">
      <div className="relative">
        <Flame 
          size={flameSize} 
          className={`${getFlameColor()} ${getGlow()} transition-all duration-150`}
          style={{
            transform: flicker ? 'scaleY(1.1) scaleX(0.95)' : 'scaleY(1) scaleX(1)',
          }}
          fill="currentColor"
        />
        {streak >= 7 && (
          <Flame 
            size={flameSize * 0.6} 
            className={`absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1 ${getFlameColor()} opacity-50`}
            style={{
              transform: flicker ? 'scaleY(0.9)' : 'scaleY(1.1)',
            }}
            fill="currentColor"
          />
        )}
      </div>
      <span className={`${textSize} font-bold ${getFlameColor()}`}>
        {streak}
      </span>
    </div>
  );
}
